import useSWR from 'swr';
import type { SignalsResponse } from '../types';

// PRD §3 spec keeps the dashboard polling cadence at 60s on the heavy
// `/api/v1/signals` endpoint. While any card is still `:evaluating`, poll
// faster so hourly/daily/weekly/monthly background evals surface quickly.
const REFRESH_INTERVAL_MS = 60 * 1000;
const EVALUATING_REFRESH_INTERVAL_MS = 5 * 1000;

export const useSignals = () => {
  const swr = useSWR<SignalsResponse>('/api/v1/signals', {
    refreshWhenHidden: false,
    revalidateOnFocus: true,
    keepPreviousData: true,
    refreshInterval: (latestData) => {
      const evaluating = latestData?.signals?.some(
        (signal) => !signal.is_hidden && signal.status === 'evaluating'
      );
      return evaluating ? EVALUATING_REFRESH_INTERVAL_MS : REFRESH_INTERVAL_MS;
    }
  });

  return swr;
};
